import { Link } from 'react-router-dom'
import { fetchBackofficeDashboard } from '../../api/stats'
import type { WidgetProps } from './types'
import { useWidgetData } from './useWidgetData'
import { Stat, WidgetBody, formatNum } from './WidgetBody'

/** I riquadri del backoffice: da verificare, integrazioni richieste, ferme da oltre 48 ore. */
export function BackofficeSummaryWidget(props: WidgetProps) {
  void props
  const state = useWidgetData(() => fetchBackofficeDashboard(), 'bo')
  return (
    <WidgetBody state={state}>
      {s => (
        <>
          <div className="md-mini-stats">
            <Stat label="Da verificare" value={formatNum(s.pendingVerification)} />
            <Stat label="Integrazioni richieste" value={formatNum(s.integrationRequested)} />
            <Stat label="Pronte all'invio" value={formatNum(s.readyForDispatch)} />
            <Stat label="Ferme oltre 48 h" value={formatNum(s.staleOver48h)} />
          </div>
          <Link to="/backoffice" className="md-typescale-body-small d-inline-block mt-2">
            Apri il backoffice
          </Link>
        </>
      )}
    </WidgetBody>
  )
}
